// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 332) return "static/css/332.f5e578669.chunk.css";
	// return url for filenames based on template
	return undefined;
};